import React from "react";
import { Card, CardContent, Typography, Button } from "@mui/material";
import { getUserBasicDetailFromAuth } from "../../utils/common";
import { useTranslation } from "react-i18next";
import { getProcurementNextAction } from "../../utils/biomassProcurement";

const ProcurementCard = ({ procurement, navigate }) => {
  const { role } = getUserBasicDetailFromAuth();
  const { t } = useTranslation();
  const { path, label } = getProcurementNextAction(
    procurement.id,
    procurement.status,
    role
  );
  return (
    <Card>
      <CardContent spacing={2}>
        <Typography variant="h6" mb={1}>
          {procurement.farmer_name}
        </Typography>
        <Typography variant="body2">
          {t("Crop")}: {procurement.crop_name}
        </Typography>
        <Typography variant="body2">
          {t("Quantity(kg)")}: {procurement.quantity_kg}
        </Typography>
        <Typography variant="body2">
          {t("Estimated Payout")}: {t("Rs")}. {procurement.estimated_payout}
        </Typography>
        <Typography variant="body2">
          {t("Paid Amount")}: {t("Rs")}. {procurement.paid_amount}
        </Typography>
        <Typography variant="body2">
          {t("Status")}: {procurement.status}
        </Typography>
        <Button
          variant="contained"
          color="primary"
          onClick={() => navigate(path)}
          sx={{ mt: 2 }}
          fullWidth
        >
          {label}
        </Button>
      </CardContent>
    </Card>
  );
};

export default ProcurementCard;
